import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { UserService } from '../services/user.service';
import { CheckEmail } from '../services/validators/check-email.validator';
import { fadeInUp } from '../services/animations/fadeInUp.animation'

import { JwtHelper } from 'angular2-jwt';

let jwtHelper: JwtHelper = new JwtHelper();

@Component({
    selector: 'app-verify-account',
    templateUrl: './verify-account.component.html',
    animations: [fadeInUp]
})
export class VerifyAccountPageComponent implements OnInit {

    verifyAccount: FormGroup;
    verifyToken: string;
    showPage: Boolean = false;
    formSubmitted: Boolean = false;
    errors: any = [];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private fbuilder: FormBuilder,
        private userService: UserService
    ) {
        this.verifyAccount = fbuilder.group({
            'email': [null, Validators.compose([Validators.required, CheckEmail])]
        });
        this.formChanges()

        this.verifyToken = this.route.snapshot.params['token'];
        if (this.verifyToken && this.verifyToken === 'invalid') {
            this.showPage = true;
            this.errors.push({ message: 'Invalid verification link'})
        } else if (this.verifyToken) {
            try {
                jwtHelper.getTokenExpirationDate(this.verifyToken);
                const body = {
                    token: this.verifyToken
                }
                this.userService.verifyUser(body).then((result: any) => {
                    if (result) {
                        this.changeRoute(true);
                    }
                }).catch(error => {
                    this.changeRoute(false);
                });

            } catch (error) {
                this.changeRoute(false)
            }
        } else {
            this.showPage = true;
        }
    }

    ngOnInit() {
    }

    formChanges() {
        this.verifyAccount.valueChanges.subscribe(val => {
            this.errors = [];
        });
    }

    changeRoute(isValid: Boolean) {
        if (isValid) {
            this.router.navigate(['/login/verify-success']);
        } else {
            this.showPage = true;
            this.errors.push({ message: 'Invalid verification link' })
            this.router.navigate(['/verify-account/invalid']);
        }
    }

    submitverifyAccount(isValid: boolean, submission) {
        if (isValid) {
            this.formSubmitted = true;
            this.userService.verifyUserForm(submission).then((res: any) => {
            }).catch(err => {
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/login/verify-account.component.ts